import KpiOther from "./kpiOther.jsx";
import KpiMain from "./kpiMain.jsx";

function KpiTeam({ dataKpi = null }) {
  return (
    <>
      <h4>{dataKpi.instructorName}</h4>
      <hr></hr>
      {(dataKpi?.main ?? []).length > 0 ? (
        <>
          <div>
            <KpiMain dataKpi={dataKpi} />
          </div>
          <div>
            <div className="col-xl-12 mb-3">
              <h5>OTHER ACTIVITY</h5>
              <KpiOther dataKpi={dataKpi} />
            </div>
          </div>
        </>
      ) : (
        ""
      )}
    </>
  );
}

export default KpiTeam;
